/********************************************************************************
 * Copyright (c) 2022 Cedalo GmbH
 *
 * All rights reserved. This program and the accompanying materials
 * are made available under the terms of the Eclipse Public License 2.0 which accompany this distribution.
 * and Eclipse Distribution License v1.0 which accompany this distribution.
 *
 * The Eclipse Public License is available at
 *   https://www.eclipse.org/legal/epl-2.0/
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
const getParent = (node, level) => {
	const parent = node.parent;
	return parent.level >= level ? getParent(node.parent, level) : parent;
};
const insert = (node) => {
	const doIt = node.key != null;
	if (doIt) {
		// find parent
		const parent = getParent(node, node.level);
		parent.kids[node.key] = node;
	}
	return doIt;
};
// DL-1305: stronger constraints for arrays
// all keys are numbers => first key must be 0 & last must be length -1!!
// const isArray = (node, keys) => keys[0] === '0' && keys[keys.length - 1] === `${keys.length - 1}`;
const isArray = (keys) => keys.reduce((isArr, key, index) => isArr && key === `${index}`, true);

const toJSON = (node, json) => {
	const kids = node.kids;
	const keys = Object.keys(kids);
	// eslint-disable-next-line no-nested-ternary
	const parent = keys.length ? (isArray(keys) ? [] : {}) : node.value;
	// const parent = keys.length ? (isArray(node, keys) ? [] : {}) : node.value;
	json[node.key] = parent;
	keys.forEach((key) => toJSON(kids[key], parent));
	return json;
};
const rangeToJSON = (sheetrange) => {
	const root = { level: -1, kids: {} };
	let node = { parent: root, kids: {}, value: null };
	sheetrange.iterate((cell, index, next) => {
		if (next && insert(node)) {
			node = { parent: node, kids: {}, value: null };
		}
		if (cell) {
			// first cell value always defines key...
			if (node.key != null) node.value = cell.cellValue != null ? cell.cellValue : node.value;
			node.key = node.key != null ? node.key : cell.cellValue;
			node.level = node.level != null ? node.level : cell.level;
		}
	});
	insert(node);
	root.key = 'root';
	return toJSON(root, {}).root || {};
};

const cellProperties = (index, pm) => pm.getCellProperties(index.col, index.row);
const hasAttributeKey = (properties) => properties && properties.attributes.key;

const isJSONRange = (range) => {
	const sheet = range.sheet;
	if (sheet) {
		const pm = sheet && sheet.properties;
		return !!(hasAttributeKey(cellProperties(range.start, pm)) && hasAttributeKey(cellProperties(range.end, pm)));
	}
	return false;
};

module.exports = {
	isJSONRange,
	rangeToJSON
};
